import { StatusModal } from "@components";

type InfractionSuccessModalProps = {
	isOpen: boolean;
	variant: "create" | "edit";
	onClose: () => void;
};

const COPY = {
	create: {
		title: "Infração cadastrada com sucesso!",
		description:
			"Clique no botão abaixo para ser direcionado para a tela principal do Módulo de Gestão de Infrações",
		confirmLabel: "Confirmar",
	},
	edit: {
		title: "Infração atualizada com sucesso!",
		description:
			"Clique no botão abaixo para ser direcionado para a tela principal do Módulo de Gestão de Infrações",
		confirmLabel: "Confirmar",
	},
} as const;

export function InfractionSuccessModal({
	isOpen,
	variant,
	onClose,
}: InfractionSuccessModalProps) {
	const content = COPY[variant];

	return (
		<StatusModal
			actions={[{ label: content.confirmLabel, onClick: onClose }]}
			description={content.description}
			isOpen={isOpen}
			onClose={onClose}
			title={content.title}
			variant="success"
		/>
	);
}
